(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-noir-showcase"] && !Shopify.designMode) return;
  try {
    
  function initLandingNoirCarousels() {
    document.querySelectorAll('[data-landing-noir-carousel]').forEach((carousel) => {
      if (carousel.dataset.landingNoirCarouselInit) return;
      carousel.dataset.landingNoirCarouselInit = 'true';

      const frames = carousel.querySelectorAll('.landing-noir__carousel-frame');
      if (frames.length < 2) return;

      const interval = parseInt(carousel.dataset.interval, 10) || 10000;
      let index = 0;

      setInterval(() => {
        frames[index].classList.remove('is-active');
        index = (index + 1) % frames.length;
        frames[index].classList.add('is-active');
      }, interval);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLandingNoirCarousels);
  } else {
    initLandingNoirCarousels();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
